export default __webpack_public_path__ + "static/media/web1.80f2fd9b.jpg";